import { IScatterShapeBreakPoint } from 'interfaces/i-pitch-performance';

const DIAMETER_PX = 8;
const RADIUS_PX = DIAMETER_PX / 2;

// ? transparent circle makes triggering the tooltip easier
export const BreakCross = ({
  cx,
  cy,
  payload,
  opacity = 1,
  onMouseEnter,
  onMouseLeave,
}: IScatterShapeBreakPoint) => {
  if (cx === undefined || cy === undefined || !payload) {
    return null;
  }

  return (
    <g
      opacity={opacity}
      stroke={`rgb(${payload.fillRgb})`}
      strokeWidth={1}
      strokeLinecap="round"
      onMouseEnter={onMouseEnter}
      onMouseLeave={onMouseLeave}
    >
      <circle
        cx={cx}
        cy={cy}
        r={DIAMETER_PX}
        fill="transparent"
        stroke="none"
        pointerEvents="all"
      />
      <line
        x1={cx - RADIUS_PX}
        y1={cy - RADIUS_PX}
        x2={cx + RADIUS_PX}
        y2={cy + RADIUS_PX}
      />
      <line
        x1={cx - RADIUS_PX}
        y1={cy + RADIUS_PX}
        x2={cx + RADIUS_PX}
        y2={cy - RADIUS_PX}
      />
    </g>
  );
};
